import React from 'react';
import PropTypes from 'prop-types';
import { buildCompanyLogoSrc } from './constants';

import './CompanyLogo.scss';

export const CompanyLogo = ({ src, alt, href }) => {
    const logoSrc = buildCompanyLogoSrc(src);
    return (
        <a
            className="component-JobV3-Elements-CompanyLogo"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
        >
            <img className="company-logo-image" src={logoSrc} alt={alt} />
        </a>
    );
};

CompanyLogo.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    href: PropTypes.string.isRequired,
};

CompanyLogo.defaultProps = {
    src: '/v1/icons/company_2x.png',
    alt: 'company-logo',
};

CompanyLogo.displayName = 'CompanyLogo';

export default React.memo(CompanyLogo);
